<div class="row">
    <div class="col-12">
      <div class="content-header">Checklist Form</div>
    </div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <form [formGroup]="checklist_form">
                    <fieldset class="form-group">
                      <label>Display Name<span class="required_field">*</span></label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="displayname" [(ngModel)]="checklist_model.displayname"
                        placeholder="Enter display name"
                        required
                      #displayname/>
                      <div
                        *ngIf="
                        rf.displayname.touched &&
                          (rf.displayname.invalid ||
                            rf.displayname.errors?.required)
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> displayname
                        is required
                      </div>
                    </fieldset>
                    <fieldset class="form-group">
                        <label>Name<span class="required_field">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="name" [(ngModel)]="checklist_model.name"
                          placeholder="Enter name"
                          required
                        #name/>
                        <div
                          *ngIf="
                          rf.name.touched &&
                            (rf.name.invalid ||
                              rf.name.errors?.required)
                          "
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> name
                          is required
                        </div>
                      </fieldset>
                      <fieldset class="form-group">
                        <label class="form-control-label">
                          Employee Type
                        </label>
                        <ng-select
                          [items]="emp_typeList"
                          bindLabel="displayname"
                          bindValue="_id"
                          placeholder="Select  Employee Type"
                          [multiple]="true"
                          [(ngModel)]="selected_emp_type"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="getTypeId($event)"
                          #emp_type
                        >
                        </ng-select>
                      </fieldset>
                      <fieldset class="form-group">
                        <label class="form-control-label">
                          List Type<span class="required_field">*</span>
                        </label>
                        <ng-select
                          [items]="list_type"
                          bindLabel="displayname"
                          bindValue="_id"
                          placeholder="Select Type"
                          [(ngModel)]="selected_type_list"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="getTypeListId($event)"
                        >
                        </ng-select>
                      </fieldset>
                      <fieldset class="form-group">
                        <label>Description</label>
                        <textarea name="" id=""  class="form-control"
                        formControlName="description" [(ngModel)]="checklist_model.description"
                        placeholder="Enter description" cols="30" rows="2"></textarea>
                      </fieldset>
                      <fieldset class="form-group" *ngIf="selected_type_name =='quick'">
                        <label>Body</label>
                        <textarea name="" id=""  class="form-control"
                        formControlName="body" [(ngModel)]="checklist_model.body"
                        placeholder="Enter body" cols="30" rows="2"></textarea>
                      </fieldset>
                    <fieldset class="form-group" *ngIf="selected_type_name =='quick'">
                      <label>Notes</label>
                      <textarea name="" class="form-control" placeholder="Enter notes"
                      formControlName="notes" [(ngModel)]="checklist_model.notes"
                       id="" cols="30" rows="1"></textarea>
                    </fieldset>
                    <fieldset class="form-group" *ngIf="selected_type_name =='quick'">
                      <label>Admin Notes</label>
                      <textarea name="" class="form-control" placeholder="Enter admin notes"
                      formControlName="admin_notes" [(ngModel)]="checklist_model.admin_notes"
                       id="" cols="30" rows="1"></textarea>
                    </fieldset>
                  </form>
                </div>
                <div class="col-md-6">
                  <form [formGroup]="checklist_form">
                    <fieldset class="form-group" *ngIf="selected_type_name !='quick' || selected_type_name ==null ">
                        <label>Body</label>
                        <textarea name="" id=""  class="form-control"
                        formControlName="body" [(ngModel)]="checklist_model.body"
                        placeholder="Enter body" cols="30" rows="2"></textarea>
                      </fieldset>
                    <fieldset class="form-group" *ngIf="selected_type_name !='quick' || selected_type_name ==null">
                      <label>Notes</label>
                      <textarea name="" class="form-control" placeholder="Enter notes"
                      formControlName="notes" [(ngModel)]="checklist_model.notes"
                       id="notes" cols="30" rows="1"></textarea>
                    </fieldset>
                    <fieldset class="form-group" *ngIf="selected_type_name !='quick' || selected_type_name ==null ">
                      <label>Admin Notes</label>
                      <textarea name="" class="form-control" placeholder="Enter admin notes"
                      formControlName="admin_notes" [(ngModel)]="checklist_model.admin_notes"
                       id="admin_notes" cols="30" rows="1"></textarea>
                    </fieldset>
                    <div *ngIf="this.currentUrl !== 'edit/:id'" id="check-list-box">
                      <div *ngFor="let item of keyValues; let i = index" class="key-value-input d-flex">
                        <input class="input-key" type="text" placeholder="Key" [(ngModel)]="item.key" name="key_{{i+1}}" [ngModelOptions]="{ standalone: true }">
                        <input class="input-value" type="text" placeholder="Value" [(ngModel)]="item.value" name="value_{{i+1}}" [ngModelOptions]="{ standalone: true }">
                        <button class="btn btn-primary mb-1" (click)="removeItem(i)">-</button>
                      </div>
                      <button *ngIf="selected_type_name =='quick'" class="btn btn-primary" (click)="addItem()">+</button>
                    </div>
                    <div *ngIf="this.currentUrl === 'edit/:id'" id="check-list-box">
                      <div *ngFor="let item of key_Values; let i = index" class="key-value-input d-flex">
                        <input class="input-key" type="text" placeholder="Key" [(ngModel)]="item[0]" name="key_{{i+1}}" [ngModelOptions]="{ standalone: true }">
                        <input class="input-value" type="text" placeholder="Value" [(ngModel)]="item[1]" name="value_{{i+1}}" [ngModelOptions]="{ standalone: true }">
                        <button class="btn btn-primary mb-1" (click)="removeItemm(i)">-</button>
                      </div>
                      <button *ngIf="selected_type_name =='quick'" class="btn btn-primary" (click)="addItemm()">+</button>
                    </div>
                  
                    <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button [disabled]="isSubmitDisabled()"
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      (click)="submit()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  